export default "__VITE_ASSET__Cew7OcgZ__"